import React from 'react';
import { 
  // Link, 
  useLocation,
  useNavigate } from 'react-router-dom';
import AuthSplitLayout from '../../../components/auth/AuthSplitLayout';
import { useLogin } from '../../../services/query/auth/auth';
import Button from '../../../components/shared/Button';
import FormField from '../../../components/shared/FormField';
import Input from '../../../components/shared/Input';
import Alert from '../../../components/shared/Alert';
import { queryClient } from '../../../lib/query';
import { showToast } from '../../../lib/utils/toast';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const { mutateAsync: login, isPending, error } = useLogin();

  const onSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const username = formData.get('username') as string;
    const password = formData.get('password') as string;
    const response = await login({ username, password });
    localStorage.setItem('access_token', response.access_token);

    // Ensure the authenticated user cache is refreshed.
    queryClient.invalidateQueries({ queryKey: ['me'] });

    showToast.success('Logged in successfully');

    const from = (location.state as { from?: string } | null)?.from;
    navigate(from || '/dashboard', { replace: true });
  };

  return (
    <AuthSplitLayout
      title="Welcome back"
      subtitle="Sign in with your username and password"
    >
      <form onSubmit={onSubmit} className="space-y-5">
        <FormField label="Username" htmlFor="username" required>
          <Input
            id="username"
            name="username"
            type="text"
            autoComplete="username"
            required
            placeholder="username"
          />
        </FormField>

        <FormField label="Password" htmlFor="password" required>
          <Input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            placeholder="••••••••"
          />
        </FormField>

        {error ? <Alert variant="error">{error.message}</Alert> : null}

        {/* <div className="flex items-center justify-between">
          <Link
            to="/forgot-password"
            className="text-sm font-medium text-green-700 hover:text-green-800"
          >
            Forgot password?
          </Link>
        </div> */}

        <Button type="submit" className="w-full" loading={isPending}>
          {isPending ? 'Signing in...' : 'Sign in'}
        </Button>
      </form>
    </AuthSplitLayout>
  );
}
